export enum MembershipLevel {
  Classic = 'CLSC',
  Plus = 'Plus',
  Premier = 'Prem',
  ClassicRV = 'CLRV',
  PlusRV = 'PLRV',
  PremierRV = 'PRRV',
}

export enum Flow {
  JOIN = 'JOIN',
  REJOIN = 'REJOIN',
}

export enum MembershipApp {
  MSS = 'mss',
  NewJoin = 'newjoin',
}

export enum AuditType {
  CreateCustomer = 'create-customer',
  CreateMembership = 'create-membership',
  CreateManifest = 'create-manifest',
  Payment = 'payment',
  SendEmail = 'send-email',
  GetMemberHouseholdInfo = 'get-member-household-info',
}

export enum AuditStatus {
  Initiated = 'initiated',
  Processing = 'processing',
  Succeeded = 'succeeded',
  Failed = 'failed',
  Exception = 'exception',
}

export enum BillPlan {
  AM = 'AM',
  AC = 'AC',
  AH = 'AH',
  MP = 'MP',
  AD = 'AD',
  AX = 'AX',
  BA = 'BA',
}

export enum PaymentMethod {
  CREDIT_CARD = 'CCRD',
  E_CHECK = 'ECHK',
  CASH = 'CASH',
  CHECK = 'CHCK',
  DEBIT_CARD = 'DCRD',
  NONE = 'NONE',
}

export enum CartItemCode {
  SERVICELEVEL = 'SERVICELEVEL',
  ADMISSION = 'ADMISSION',
  ADULT = 'ADULT',
  DEPENDENT = 'DEPENDENT',
  ASSOCIATE = 'ASSOCIATE',
  FIRSTASSOCIATE = 'FIRSTASSOCIATE',
  RV = 'RV',
  MEDRIDER = 'MEDRIDER',
  AUTOPAY = 'AUTOPAY',
  CAMPAIGN = 'CAMPAIGN',
  PASTDUEAMOUNT = 'PASTDUEAMOUNT',
  HACDISCOUNT = 'HACDISCOUNT',
  CONVFEE = 'CONVFEE',
  ERSFEE = 'ERSFEE',
  MEMBERSHIPDISCOUNT = 'MEMBERSHIPDISCOUNT',
}

export enum ErrorType {
  CACHE_NOT_FOUND = 'Cache not found',
  CLUB_CODE_NOT_ACCEPTED = 'CLUB_CODE_NOT_ACCEPTED',
}

export enum Pages {
  LandingPage = '/landing',
  SorryPage = '/sorry',
  ContactDetailsPage = '/contact',
  AddressPage = '/address',
  ReviewPage = '/review',
  BuildMembershipPage = '/buildmembership',
  AddAssociatePage = '/addassociate',
  ConfirmationPage = '/confirmation',
  BenefitsPage = '/benefits',
  AutopayPage = '/autopay',
  CreateMembershipStatusPage = '/membershipstatus',
  AdditionalBenefitsPage = '/additionalbenefits',
  MemberExists = '/memberexists',
  DateSelector = '/dateselector',
  SendMembershipCardPage = '/sendmemcardbill',
  GiftDonorContactPage = '/giftdonorcontact',
  GiftDonorAddressPage = '/giftdonoraddress',
  SendGiftCardPage = '/sendgiftcard',
  GiftRecipientClubMismatchPage = '/giftrecipientclubmismatch',
  VoucherStatus = '/voucherstatus',
  PartnerMemberExists = '/partnermemberexists',
  OfferNotAvailable = '/offernotavailable',
  PartnerEnrollment = '/partner-offers',
  MaintenancePage = '/maintenance',
}

export enum ContentStatus {
  Staging = 'Staging',
  Ready = 'Ready',
  Live = 'Live',
}
export enum ClubCode {
  alabama = '001',
  calif = '004',
  hawaii = '018',
  northernnewengland = '036',
  autoclubmo = '065',
  eastcentral = '215',
  texas = '252',
  tidewater = '258',
  newmexico = '601',
  unknown = '000',
}

export enum AWSRegions {
  USWest2 = 'us-west-2',
  USEast1 = 'us-east-1',
}
